<template>
  <div>
    <div v-if="sold || soldConditionally">
      <span class="title d-block w-100">
        {{ I18n.t(`live_auctions.state.${soldState}`) }}
      </span>
      <span
        class="price price--highlight"
        :class="{ 'price--conditionally': soldConditionally }"
      >
        {{ I18n.t("artworks.price", { price: formatPrice(auction.value) }) }}
      </span>
      <span class="price--with-commission">
        {{ I18n.t("artworks.price_with_commission", { price: formatPrice(auction.valueWithCommission) }) }}
      </span>
      <div
        v-if="internetAuctionType"
        class="mb-4"
      >
        {{ I18n.t("internet_auctions.auction.number_of_offers", { count: auction.bidsCount }) }}
      </div>
    </div>
    <div
      v-else
      class="title d-block mb-2"
      :class="{ 'mb-4': internetAuctionType }"
    >
      {{ I18n.t("live_auctions.state.unsold") }}
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { FINISHED_STATES } from './../../consts';
  import ComputeArtworkState from './../../mixins/compute_artwork_state';
  import { formatNumber } from './../../helpers';

  export default {
    name: 'ArtworkState',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['findAuction']),
      auction() {
        return this.findAuction(this.artwork.id);
      },
      soldState() {
        return this.soldConditionally ? FINISHED_STATES.SOLD_CONDITIONALLY : FINISHED_STATES.SOLD;
      },
      internetAuctionType() {
        const auctionType = this.auction.type;
        return auctionType === 'internet_auctions';
      },
    },
    mixins: [ComputeArtworkState],
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/modal/artwork_state.vue?a19ffb58